import React from "react";
import HelpTicketDetail from "@/pages/HelpTicketDetail";

/**
 * Thin wrapper. Renders the shared `HelpTicketDetail` with a basePath that
 * routes the back-link to the super-admin inbox instead of the customer's
 * `/help/tickets`. All super-admin extras (internal note, status controls,
 * priority/category change) are gated on `useAuth().user.role === "super_admin"`
 * inside the shared component.
 */
export default function SuperAdminTicketDetail() {
  return <HelpTicketDetail basePath="/super-admin/tickets" />;
}
